import { Component } from '@angular/core';

import { NavController, MenuController } from 'ionic-angular';

import { InAppBrowser } from 'ionic-native';

import { Http } from '@angular/http';

import 'rxjs/add/operator/map';



import { Jobs } from '../jobs/jobs';
import { UserData } from '../../providers/user-data';


@Component({
  templateUrl: 'build/pages/login/login.html'
})
export class LoginPage {


  login: {username?: string, password?: string} = {};
  submitted = false;
  testreq: any = null;

  constructor(public navCtrl: NavController, public userData: UserData,  public menu: MenuController, private http: Http) {

 this.menu.swipeEnable(false, 'menu');

 
     }

  onLogin(form) {
    this.submitted = true;

    if (form.valid) {


   document.getElementById("msg").innerText = '';

  var link = 'http://www.letpco.co.uk/api/v1/auth';

  var data = JSON.stringify({email: this.login.username,pwd : this.login.password});

        
        this.http.post(link, data)
        .subscribe(data => {
    this.testreq = data.json();


console.log(this.testreq.key);
console.log(this.testreq.status);

if(this.testreq.status === 'ok')
{


this.userData.login(this.testreq.key);

this.navCtrl.setRoot(Jobs);




}
else
{
   document.getElementById("msg").innerText = 'Check Login info !';
}

        }, error => {
            document.getElementById("msg").innerText = "Check Internet Connection !";
        });





    }
  }

  onSignup() {

   new InAppBrowser('http://www.letpco.co.uk/drivers', '_system');

  }

onForgot()
{

 new InAppBrowser(' http://www.letpco.co.uk/client/forgot.php', '_system');
 
}

}
